define(function (require) {

    /////////////////////////////////// IMPORT DEPENDENCIES ///////////////////////////////////

    var AMSStatics = window.lpTag.AMSStatics || {};
    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseController = require('web-agent-assets-js/BaseController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var leConf = require("assets/config/le-conf");

    var amsCommunicationChannel = webAgentStatics.COMMUNICATION_CHANNELS.AMS;

    /////////////////////////////////// CONSTANT VARIABLES ///////////////////////////////////
    var API_VERSION = '2';
    if (!!agentLEManager.getFeatureProperty("Messaging.Transfer_To_Agent")) {
        API_VERSION = '2.1';
    }

    var APPLICATION_TYPE = 'lpAMSConnectionController';
    var PRIMARY_UMS_SERVER_CSDS_KEY = 'facadeMsg';
    var SECONDARY_UMP_SERVER_CSDS_KEY = 'asyncMessagingEnt';

    /////////////////////////////////// CLASS GLOBALS ///////////////////////////////////
    var logger = WebAgentLogger.getLogger(APPLICATION_TYPE);

    /////////////////////////////////// CLASS DEFINITION ///////////////////////////////////

    /**
     * AMSConnection Controller Class.
     */
    var AMSConnectionController = BaseController.extend(function AMSConnectionControllerConstructor() {
        this._amsClientInstance = null;
        this.connectionState = null;
        var amsServerDomain = getServerDomain();

        // var useCQMMode = true;
        // 'facade-msg.dev.lprnd.net' - With Groups    (CQM)
        // qatrunk.dev.lprnd.net' -     without groups (No CQM)
        // if ( useCQMMode ) {
        //     amsServerDomain = 'facade-msg.dev.lprnd.net';
        // }
        // else {
        //     amsServerDomain = 'qatrunk.dev.lprnd.net';
        // }
        // window.lpTag.WebAgent.logicController.needAllOperatorsDataList = function(){
            // return !useCQMMode;
        // }

        this.baseClientSettings = {
            apiVersion: API_VERSION,
            token: agentLEManager.getGlobLE(),
            memberType: AMSStatics.memberTypes.AGENT,
            domain: amsServerDomain,
            accountId: this.model.get('account')
        };

        logger.debug('AMSConnection Controller Created.');
    });

    AMSConnectionController.prototype.applicationType = APPLICATION_TYPE;

    /////////////////////////////////// CLASS PROTOTYPE ///////////////////////////////////

    /*
     * public api for the instance.
     * ==================================================
     * */

    /**
     * Initializing the class, open the connection.
     */
    AMSConnectionController.prototype.init = function () {
        this.openConnection();
    };
    /**
     * create a new instance of the AMSClient and open a connection.
     */
    AMSConnectionController.prototype.openConnection = function () {
        var amsClientSettings = _.extend(this.baseClientSettings, {
            onSocketConnected: {func: this.onSocketConnected, context: this},
            onSocketClosed: {func: this.onSocketClosed, context: this},
            onServiceNonResponsive: {func: this.onServiceNonResponsive, context: this},
            onPingSuccess: {func: this.onPingSuccess, context: this},
            onMessageReceive: {func: this.onMessageReceive, context: this},
            onEventNotification: {func: dispatchEvent, context: {name: amsCommunicationChannel.events.onEventNotification}},
            onExConversationNotification: {func: dispatchEvent, context: {name: amsCommunicationChannel.events.onExConversationNotification}},
            onBrandProfile: {func: dispatchEvent, context: {name: amsCommunicationChannel.events.onBrandProfile}},
            onUserInfo: {func: dispatchEvent, context: {name: amsCommunicationChannel.events.onUserInfo}},
            onRingUpdate: {func: dispatchEvent, context: {name: amsCommunicationChannel.events.onRingUpdate}},
            onRoutingUpdate: {func: dispatchEvent, context: {name: amsCommunicationChannel.events.onRoutingUpdate}}
        });

        logger.debug('initializing a new connection');

        this._amsClientInstance = new window.lpTag.AMSClient();
        this._amsClientInstance.init(amsClientSettings);

        this.resetClientDeferred = _.after(3, this.resetConnection);
    };
    /**
     * close the connections and Disposing of the AMSClient instance.
     */
    AMSConnectionController.prototype.closeConnection = function () {
        logger.debug('closing connection with the ams');
        if (this._amsClientInstance) {
            if (this._amsClientInstance.dispose) {
                this._amsClientInstance.dispose();
            }
            this._amsClientInstance = null;
        }
        updateConnectionState(this, lpAMSController.SOCKET_STATES.CLOSED);
    };
    /**
     * reset the connection to the AMSClient.
     */
    AMSConnectionController.prototype.resetConnection = function () {
        logger.debug('resetting connection with the ams');
        this.closeConnection();
        this.openConnection();
    };
    /**
     * Disposing the class memory and allocations.
     */
    AMSConnectionController.prototype.dispose = function () {
        logger.debug('disposing the ams connection.');
        this.closeConnection();
    };

    /*
     * Instance events handlers.
     * ==================================================
     * */

    /**
     * handle Socket Connected event.
     */
    AMSConnectionController.prototype.onSocketConnected = function () {
        updateConnectionState(this, lpAMSController.SOCKET_STATES.CONNECTED);
    };
    /**
     * handle Socket Closed event.
     */
    AMSConnectionController.prototype.onSocketClosed = function () {
        updateConnectionState(this, lpAMSController.SOCKET_STATES.CLOSED);
    };
    /**
     * handle Service Non Responsive event.
     */
    AMSConnectionController.prototype.onServiceNonResponsive = function () {
        if (window.lpTag.WebAgent.logicController.isNonResponsiveDisabled()) {
            return;
        }
        updateConnectionState(this, lpAMSController.SOCKET_STATES.NON_RESPONSIVE);
        if (this.resetClientDeferred) {
            this.resetClientDeferred.call(this);
        }
    };

    AMSConnectionController.prototype.onPingSuccess = function () {
        this.setRecoverState();
    };

    AMSConnectionController.prototype.onMessageReceive = function () {
        this.setRecoverState();
    };

    AMSConnectionController.prototype.setRecoverState = function () {
        if (!this.isSocketActive()) {
            updateConnectionState(this, 'recovered');
        }

    };

    AMSConnectionController.prototype.isSocketActive = function () {
        var state = this.getModelParam('amsService.socketState');
        return state === lpAMSController.SOCKET_STATES.CONNECTED || state === 'recovered';
    };

    /*
     * Instance property, a proxy to the real ams client.
     * ==================================================
     * */

    /**
     * Creates a new property named "amsClient" that is used as a proxy to the real instance of the client.
     */
    Object.defineProperty(AMSConnectionController.prototype, 'amsClient', {
        get: function () {
            return this._amsClientInstance;
        }
    });


    /*
     * Internal Implementation
     * ==================================================
     * */

    /**
     * relay of the AMS events to the AMS channel.
     * @param data
     */
    function dispatchEvent(data) {
        if (leConf.environment === window.LE.CONST.ENVIRONMENTS.DEV) {
            logger.debug('dispatching AMS Event: [' + amsCommunicationChannel.name + ":" + amsCommunicationChannel.events[this.name] + '] => ' + JSON.stringify(data));
        }
        window.lpTag.WebAgent.channel.publish(amsCommunicationChannel.name, amsCommunicationChannel.events[this.name], data);
    }

    /**
     * updating the connection state and publish the results.
     * @param context
     * @param state
     */
    function updateConnectionState(context, state) {
        var hasStateChange = context.connectionState !== state;
        var diagnostics = window.lpTag.WebAgent.logicController && window.lpTag.WebAgent.logicController.diagnostics;
        var shouldLogExtra = diagnostics && diagnostics.isKeyActive(diagnostics.keys.socketConnectionStateChangeUMS);
        logger.debug('connection state update - new state [' + state + '] - has changes: [' + hasStateChange + ']');
        if (hasStateChange) {
            context.connectionState = state;
            window.lpTag.WebAgent.channel.publish(amsCommunicationChannel.name, amsCommunicationChannel.events.connectionStateChange, state);
            if (shouldLogExtra) {
                logger.error('UMS connection state update - new state [' + state + '] - has changed: [' + hasStateChange + ']');
            }
        }
    }

    /**
     * Resolve the Primary/Secondary Server for the UMS.
     * Based on the CSDS Service discovery.
     */
    function getServerDomain() {
        var CSDSRecordKey = agentLEManager.getCSDSRecord(PRIMARY_UMS_SERVER_CSDS_KEY) ? PRIMARY_UMS_SERVER_CSDS_KEY : SECONDARY_UMP_SERVER_CSDS_KEY;
        return lpUtils.removeProtocolFromURL(agentLEManager.getLEUrlResolverGetUrl('{' + CSDSRecordKey + '}'));
    }


    return AMSConnectionController;

});
